import {useParams, usePathname} from 'next/navigation';
import {useCallback, useEffect, useRef} from 'react';

const getCurrentAppPackageName = (
  pathname: string | null,
  params: Record<string, string | Array<string> | undefined> | null,
) => {
  if (pathname?.includes('/app/') && typeof params?.id === 'string') {
    return params.id;
  }

  return null;
};

export const useGetCurrentAppPackageName = () => {
  const pathname = usePathname();
  const params = useParams();

  const screenAppIdRef = useRef<string | null>(
    getCurrentAppPackageName(pathname, params),
  );

  useEffect(() => {
    screenAppIdRef.current = getCurrentAppPackageName(pathname, params);
  }, [pathname, params]);

  return useCallback(() => screenAppIdRef.current, []);
};
